"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessedEmailEventsCount = exports.EmailEvents = exports.EmailEvent = exports.EmailEventsSource = void 0;
const typebox_1 = require("@sinclair/typebox");
var EmailEventsSource;
(function (EmailEventsSource) {
    EmailEventsSource["SENDGRID"] = "sendgrid";
})(EmailEventsSource || (exports.EmailEventsSource = EmailEventsSource = {}));
// Keep email event payload schema generic to agnostically support email services
exports.EmailEvent = typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Any());
exports.EmailEvents = typebox_1.Type.Array(exports.EmailEvent);
exports.ProcessedEmailEventsCount = typebox_1.Type.Object({
    processedEventsCount: typebox_1.Type.Number(),
});
//# sourceMappingURL=email-events.js.map